import * as priceFactorsGroups from './priceFactorsGroups';
import * as priceFactorsProductCodes from './priceFactorsProductCodes';
import * as priceFactorsList from './priceFactorsList';

const reducers = {
  ...priceFactorsGroups,
  ...priceFactorsProductCodes,
  ...priceFactorsList,
};

export default reducers;
